module.exports = __webpack_public_path__ + "static/img/msg@2x.36d18ba2.png";